import React from 'react';

import {
  Typography,
  Grid
} from 'e100-react-components';
import { PaperWorkArea } from 'shared/components';
import { Filter } from './Filter/Filter';
import { FavouriteStations } from './FavouriteStations/FavouriteStations';
import { FavouriteBrands } from './FavouriteBrands/FavouriteBrands';
import { ErrorMessage } from './ErrorMessage/ErrorMessage';

import { useIntl } from 'react-intl';
import { useStyles } from './styles';
import { useApplicationOperations } from 'entities/application';
import { useIsFavouriteStationsError } from 'entities/stations';
import { useIsFavouriteBrandsError } from 'entities/brands';

import { MENU_ITEMS } from 'entities/application';

import { withFavouriteStationsModalContext } from '../../hocs';

export const FavouriteStationsModal = withFavouriteStationsModalContext(() => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const { setActiveMenuItem } = useApplicationOperations();
  const isFavouriteStationsError = useIsFavouriteStationsError();
  const isFavouriteBrandsError = useIsFavouriteBrandsError();

  return (
    <PaperWorkArea
      title={<Typography>{formatMessage({ id: 'favouriteStations' })}</Typography>}
      onClose={() => {
        setActiveMenuItem(MENU_ITEMS.map);
      }}
    >
      {
        isFavouriteStationsError && isFavouriteBrandsError
        ? (
          <ErrorMessage />
        ) : (
          <Grid
            container
            wrap="nowrap"
            direction="column"
            classes={{
              container: classes.container
            }}
          >
            <Grid item>
              <Filter />
            </Grid>
            <Grid item classes={{ root: classes.contentContainer }}>
              <Grid
                container
                wrap="nowrap"
                direction="column"
              >
                <Grid item>
                  <FavouriteBrands />
                </Grid>
                <Grid item>
                  <FavouriteStations />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )
      }
    </PaperWorkArea>
  );
});
